import { post } from '../util/ajax';

export const upsertCourseRecFeedback = body => {
  return post(`recommended-courses/feedbacks`, body);
};
